import { Link } from '@fluentui/react';
import { Link as DomLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { DefaultCard } from 'component/DefaultCard';
import { AckTextList } from 'component/Ack';
import { useThemeData } from '@msrceng/theme';
import { ICveNumber } from '../../../../../api/apiTypes';
import { useAcknowledgementInfiniteApiFromCveNumber } from '../../../../../api/ack';
import { groupAcksByCveNumber } from '../../../../context/Ack/groupAcksByCveNumber';
import { map } from 'lodash';
import { MessageError } from '@msrceng/component';

export const AcknowledgementListView = ({ cveNumber }: ICveNumber) => {
  const [t] = useTranslation('vulnerability');
  const { theme } = useThemeData();
  const { data, isLoading, error } = useAcknowledgementInfiniteApiFromCveNumber(
    cveNumber,
    {
      enabled: !!cveNumber,
    }
  );

  const groupedAckData = groupAcksByCveNumber(data?.pages?.flat(1));

  return (
    <DefaultCard
      id='acknowledgements'
      header={t('acknowledgements.Acknowledgements')}
      loading={!data && isLoading}
    >
      {error && <MessageError error={error} />}
      <div
        style={{
          background: theme.semanticColors?.infoBackground,
          borderRadius: theme.effects.roundedCorner2,
          boxShadow: theme.effects.elevation4,
          padding: theme.spacing.s2,
        }}
      >
        {data &&
          map(groupedAckData, (ack, i) => (
            <AckTextList
              key={`Ack text list ${ack.ackText?.join(',')} - ${i}`}
              cveAck={ack}
            />
          ))}
      </div>
      <Trans
        t={t}
        i18nKey='acknowledgements.text'
        defaults='Microsoft recognizes the efforts of those in the security community who help us protect customers through coordinated vulnerability disclosure. See <0>Acknowledgements</0> for more information.'
        components={[<LinkComponent key='linkKey' />]}
      />
    </DefaultCard>
  );
};

const LinkComponent = ({ children = '' }) => (
  <Link as={DomLink} to='/acknowledgement' key='linkKey'>
    {children}
  </Link>
);
